<footer>
  <div class="container">
    <div class="row">
      <div class="col-3">
        <span class="footer-title">Liens</span> <br />
        <ul>
          <li>
            <a href="/">Annuaires des notaires</a>
          </li>
          <li>
            <a href="/v2/mentions-legales">Mentions légales</a>
          </li>
          <li *ngIf="isCguDisplayed">
            <!-- TODO : qu'est ce qu'on doit afficher dans la partie CGU ? -->
            <a (click)="openModal(footerModalId.CGU_MODAL)">CGU</a>
          </li>
          <li>
            <a href="http://evaluanot.notaires.fr">Evalu&#64;not</a>
          </li>
          <li *ngIf="isDpoDisplayed">
            <!-- TODO : qu'est ce qu'on doit afficher dans la partie Politique de protection des données ? -->
            <a (click)="openModal(footerModalId.PPD_MODAL)"
              >Politique de protection des données</a
            >
          </li>
          <li>
            <a href="https://pro.immobilier.notaires.fr">
              Pro.immobilier.notaires.fr
            </a>
          </li>
        </ul>
      </div>

      <div class="col-3">
        <span class="footer-title">Support client</span> <br />
        <ul>
          <li class="num">0 800 710 620</li>
          <li>
            <a href="mailto:serviceclient@adnov.fr"> serviceclient&#64;adnov.fr </a>
          </li>
        </ul>
      </div>

      <div class="col-6">
        <span class="footer-title">Les références des Notaires France</span>
        <p class="references-notaires-text">
          Depuis 1994, les notaires alimentent une base de données des
          références immobilières rassemblant les mutations à titre onéreux.
          Appelée PERVAL pour les régions et BIEN pour l'Ile-de-France, son
          objectif est de fournir des éléments de comparaison pour estimer des
          biens immobiliers. Cette base, structurée selon le type de bien vendu
          (maison individuelle, appartement, terrain, garage, immeuble entier,
          local d'activité, bien viticole ou agricole), offre une source
          d'information sans équivalent pour appréhender le marché immobilier.
        </p>
      </div>
    </div>

    <span class="copyright-perval">© {{ currentYear }} Perval.fr</span>
  </div>
</footer>

<p-modal
  *ngIf="isModalCguOpen && isCguDisplayed"
  [modalId]="footerModalId.CGU_MODAL"
  title="Conditions Générales d'Utilisation"
>
  <embed type="application/pdf" [src]="cguUrl" width="100%" height="500px" />
</p-modal>

<p-modal
  *ngIf="isModalPpdOpen && isDpoDisplayed"
  [modalId]="footerModalId.PPD_MODAL"
  title="Politique"
>
  <embed type="application/pdf" [src]="ppdUrl" width="100%" height="500px" />
</p-modal>
